function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 26.5C0 11.864 11.864 0 26.5 0S53 11.864 53 26.5 41.136 53 26.5 53 0 41.136 0 26.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#464a55",
  d: "M36.87 25V36.76a2.941 2.941 0 0 1-2.94 2.94H19.228a2.941 2.941 0 0 1-2.94-2.94V25a2.941 2.941 0 0 1 2.94-2.94v-4.411c0-4.053 3.298-7.351 7.351-7.351 4.054 0 7.351 3.298 7.351 7.35v4.411A2.941 2.941 0 0 1 36.87 25zm-7.35 4.41a2.941 2.941 0 0 0-5.881 0 2.93 2.93 0 0 0 1.47 2.532v3.35h2.94v-3.35a2.93 2.93 0 0 0 1.47-2.532zm1.47-11.761a4.416 4.416 0 0 0-4.41-4.41 4.416 4.416 0 0 0-4.411 4.41v4.41h8.82z"
})));

var SvgSecurityIcon = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSecurityIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/security-icon.55dcacba.svg";
export { ForwardRef as ReactComponent };